/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeAddMarketCodeRequest, serializeDeleteMarketCodeRequest, serializeOk, type AddMarketCodeRequest, type DeleteMarketCodeRequest, type ErrorResponse, type Ok } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/market-codes
 */
export interface MarketCodesRequestBuilder extends BaseRequestBuilder<MarketCodesRequestBuilder> {
    /**
     * Removes a Market Code from an organization's suggestion list. Sales reps already carrying the code keep it — this only curates the suggestions offered when setting a code on a rep.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(body: DeleteMarketCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Adds a Market Code to an organization's suggestion list so admins can pick it when setting a code on a sales rep. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     post(body: AddMarketCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Removes a Market Code from an organization's suggestion list. Sales reps already carrying the code keep it — this only curates the suggestions offered when setting a code on a rep.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteMarketCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds a Market Code to an organization's suggestion list so admins can pick it when setting a code on a sales rep. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddMarketCodeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MarketCodesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/market-codes";
/**
 * Metadata for all the requests in the request builder.
 */
export const MarketCodesRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: MarketCodesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteMarketCodeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: MarketCodesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddMarketCodeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
